import React from 'react';
import styled from '@emotion/styled';
import { withLocale, WithLocaleProps } from 'locale';
import { ControlButton } from 'ds/components/button';
import AdjustmentsIcon from 'assets/svg/adjustments.svg';
import { useTheme } from 'hooks/useTheme';

interface NumberIconProps {
  num: number;
}

const FilterLabel = styled.span`
  ${({ theme }) => `color: ${theme.colors.neutrals.grey1};`}
`;

const RootBtn = styled(ControlButton)(() => ({
  position: 'relative',
  borderColor: 'transparent',
  padding: '0',
  'svg': {
    display: 'block',
    margin: '0',
  },
  '.active-filter-count': {
    scale: '0.8',
    position: 'absolute',
    top: '0',
    right: '0',
  },
}));

interface FilterSummaryButtonProps extends WithLocaleProps {
  isScrolled?: boolean;
  filtersNumber?: number;
  onlyIcon?: boolean;
  onClick?: (e?: React.MouseEvent) => void;
}

const FilterSummaryButton: React.FunctionComponent<FilterSummaryButtonProps> = ({
  t,
  onClick,
  onlyIcon,
  isScrolled,
  filtersNumber,
}) => onlyIcon ? (
  <RootBtn onClick={onClick} onlyIcon={isScrolled} isInitialIconColor>
    {(filtersNumber > 0) && <NumberIcon num={filtersNumber} />}
    <AdjustmentsIcon />
  </RootBtn>
) : (
  <ControlButton onClick={onClick} onlyIcon={isScrolled} isInitialIconColor>
    {filtersNumber ? <NumberIcon num={filtersNumber} /> : <AdjustmentsIcon />}
    {!isScrolled && <FilterLabel data-auto="filtersButton">{t('filters.filterResults')}</FilterLabel>}
  </ControlButton>
);

export const NumberIcon: React.FunctionComponent<NumberIconProps> = ({ num }) => {
  const theme = useTheme();
  return (
    <svg width={16} className="active-filter-count" viewBox="0 0 16 16" height={16} >
      <rect fill={theme.colors.brand.main} width={16} height={16} rx={4} ry={4}/>
      <text textAnchor="middle" style={{ font: '13px/13px NovemberHebrew' }} x={8} y={12} fill="white">{num}</text>
    </svg>
  );
};

export default withLocale(FilterSummaryButton);
